import { render, staticRenderFns } from "./PropertyRequestDocuments.vue?vue&type=template&id=60abc5ce&"
import script from "./PropertyRequestDocuments.vue?vue&type=script&lang=js&"
export * from "./PropertyRequestDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports